import { makeStyles, lighten, darken } from "@material-ui/core";
import KeyAImage from "Custom/Content/ProductSelector/key_a.png";
import KeyBImage from "Custom/Content/ProductSelector/key_b.png";

export const EditVariants = makeStyles((theme) => ({
    bqsEditFlex: {
        flex: "1",
        "& div": {
            "& input": {},
        },
    },
    bqsEditNumberFlex: {
        flex: "1",
        "& div": {
            "& input": {
                width: "80px",
            },
        },
    },
    bqsEditNumberNoLabel: {
        "& div": {
            marginTop: "0 !important",
            "& input": {
                width: "80px",
            },
        },
    },
    bqsEditNumberReadOnly: {
        "& label:not(.Mui-error)": {
            color: "#333333 !important",
        },
        "& div": {
            color: "#333333 !important",
            "& input": {
                backgroundColor: "transparent !important",
                border: "1px solid #aaaaaa !important",
                color: "#333333 !important",
                width: "80px",
            },
        },
    },
    bqsEditNumberStandard: {
        width: "160px",
        "& div": {
            "& input": {
                width: "80px",
            },
        },
    },
    bqsEditNumberLarge: {
        width: "175px",
        "& div": {
            "& input": {
                width: "80px",
            },
        },
    },
    bqsKeyAAdornment: {
        backgroundImage: `url(${KeyAImage})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        height: "25px",
        width: "25px",
    },
    bqsKeyBAdornment: {
        backgroundImage: `url(${KeyBImage})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        height: "25px",
        width: "25px",
    },
    bqsSuperScriptAdornment: {
        marginBottom: "3px",
    },
}));
